/*
 * Copyright (C) 2019-present Arctic Ice Studio <development@arcticicestudio.com>
 * Copyright (C) 2019-present Sven Greb <development@svengreb.de>
 *
 * Project:    Arctic Ocean Fractal
 * Repository: https://github.com/arcticicestudio/arctic-ocean-fractal
 * License:    MIT
 */

const fishSwarmCircles = [
  { cx: 506.47, cy: 73.944, r: 1.659 },
  { cx: 497.269, cy: 81.748, r: 1.021 },
  { cx: 507.294, cy: 86.211, r: 1.021 },
  { cx: 511.745, cy: 94.431, r: 1.539 }
];

const groundHoleCenterCircles = [
  { cx: 474.314, cy: 512.314, r: 5.168 },
  { cx: 496.762, cy: 520.93, r: 3.445 },
  { cx: 488.382, cy: 533.275, r: 3.733 },
  { cx: 492.046, cy: 551.104, r: 1.446 },
  { cx: 480.436, cy: 567.336, r: 2.212 }
];

const groundHoleOverflowCircles = [
  { cx: 374.469, cy: 530.736, r: 4.526 },
  { cx: 406.118, cy: 552.25, r: 3.52 },
  { cx: 413.85, cy: 574.08, r: 4.723 },
  { cx: 390.16, cy: 591.476, r: 5.993 },
  { cx: 396.37, cy: 623.139, r: 4.172 }
];

const groundHoleTopCircles = [
  { cx: 610.294, cy: 396.273, r: 4.157 },
  { cx: 587.557, cy: 417.539, r: 5.29 },
  { cx: 617.032, cy: 432.512, r: 1.446 },
  { cx: 605.422, cy: 448.744, r: 2.213 }
];

const waterCircles = [
  { cx: 272.146, cy: 169.538, r: 2.466 },
  { cx: 255.331, cy: 189.043, r: 3.138 },
  { cx: 271.018, cy: 211.905, r: 1.337 }
];

export { fishSwarmCircles, groundHoleCenterCircles, groundHoleOverflowCircles, groundHoleTopCircles, waterCircles };
